export function getCategorySongIdsSortedByFree(categoryKey: string, songs: any[], user: any): number[] {
  if (!categoryKey || !CATEGORIES[categoryKey as keyof typeof CATEGORIES]) {
    return [];
  }
  
  const categoryData = CATEGORIES[categoryKey as keyof typeof CATEGORIES];
  if (!categoryData || !categoryData.songIds) {
    return [];
  }

  // Se premium ou convidado, retorna na ordem original
  if (user?.tipo_de_conta === 'premium' || user?.tipo_de_conta === 'convidado') {
    return categoryData.songIds;
  }

  // Se não há músicas carregadas, retorna a ordem original
  if (!songs || songs.length === 0) {
    return categoryData.songIds;
  }

  // Se não for premium, ordena grátis primeiro
  const songObjs = categoryData.songIds
    .map(id => songs.find(s => Number(s.id) === Number(id)))
    .filter(Boolean); // Remove undefined/null

  if (songObjs.length === 0) {
    return categoryData.songIds; // Fallback para ordem original
  }

  const sorted = songObjs.sort((a, b) => {
    if (!a || !b) return 0;
    // Músicas grátis (is_free === true ou undefined) vêm primeiro
    const aIsFree = a.is_free !== false;
    const bIsFree = b.is_free !== false;
    
    if (aIsFree === bIsFree) return 0;
    return aIsFree ? -1 : 1;
  });

  return sorted.map(s => Number(s.id)).filter(id => !isNaN(id));
}

export const CATEGORIES = {
  salmos: {
    id: 'salmos',
    title: 'Salmos',
    description: 'Os salmos mais poderosos',
    songIds: [143, 144, 145, 148, 149, 150, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304]
  },
  fe: {
    id: 'fe',
    title: 'Fé',
    songIds: [17, 18, 9, 14, 10, 3, 6, 1, 145, 147, 314, 318, 319, 323, 325, 335, 338, 340, 342, 343, 349, 350, 352, 354, 361, 363, 364, 366, 370, 372, 373, 377, 382, 387, 416, 419, 420, 492, 493, 513, 517, 524]
  },
  sabedoria: {
    id: 'sabedoria',
    title: 'Sabedoria',
    songIds: [15, 11, 20, 13, 6, 7, 317, 324, 336, 346, 351, 355, 357, 362, 367, 368, 379, 514, 519]
  },
  esperanca: {
    id: 'esperanca',
    title: 'Esperança',
    songIds: [5, 4, 2, 8, 316, 320, 322, 337, 341, 345, 347, 356, 359, 360, 365, 371, 375, 376, 381, 384, 385, 386, 418, 512, 513, 518, 520, 521, 523]
  },
  amor: {
    id: 'amor',
    title: 'Amor',
    songIds: [107, 1, 20, 13, 315, 321, 325, 326, 327, 328, 329, 330, 339, 348, 353, 358, 369, 374, 378, 380, 383, 417, 510, 515, 516, 522]
  },
  proverbios: {
    id: 'proverbios',
    title: 'Provérbios',
    description: 'Versículos do livro de Provérbios musicados para trazer sabedoria e direção divina',
    songIds: [10, 305, 306, 307, 308, 309, 310, 311, 312, 313, 331, 332, 333, 334, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415]
  }
};

export const JOURNEY_STAGES = [
  {
    id: 1,
    title: "A Criação e os Primeiros Pecados",
    description: "Esta etapa apresenta o início de tudo: a criação do mundo, o jardim do Éden, a queda da humanidade, os primeiros irmãos (Caim e Abel), a corrupção da terra e a salvação de Noé no Dilúvio. Também conhecemos a Torre de Babel e o espalhamento das nações.",
    songIds: [22, 23, 453, 454, 25, 26, 455, 456, 27, 28, 29, 30, 31, 32, 33, 34, 457, 458, 459]
  },
  {
    id: 2,
    title: "Deus Chama um Povo",
    description: "A partir de Abraão, Deus estabelece um povo separado para Si. A promessa, a fé, os patriarcas, casamentos providenciais, sonhos e reconciliações mostram como Deus conduz sua aliança até o Egito, preparando o cenário para a libertação futura.",
    songIds: [35, 36, 460, 461, 37, 38, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491]
  },
  {
    id: 3,
    title: "A Libertação e a Lei",
    description: "Deus levanta Moisés para libertar seu povo da escravidão no Egito. Com sinais, pragas e milagres, o povo atravessa o Mar Vermelho. No deserto, recebe a Lei, os mandamentos e orientações para viver em aliança com o Senhor. Levítico e Números revelam a santidade, a adoração e os desafios da caminhada.",
    songIds: [39, 40, 432, 433, 434, 435, 436, 41, 42, 43, 44, 45, 46, 142, 50, 51, 123, 125, 126, 437, 438, 439, 440, 52, 53, 54, 421, 422, 423, 441, 442, 443, 444, 445, 446, 447, 448, 449, 424, 425]
  },
  {
    id: 4,
    title: "Conquista, Juízes e o Início da Monarquia", 
    description: "Josué lidera o povo na conquista da Terra Prometida. Em seguida, o período dos juízes revela ciclos de desobediência e misericórdia. Depois, o povo pede um rei: Davi é ungido, Salomão assume o trono, e o reino é estabelecido, mas também dividido.",
    songIds: [450, 69, 70, 71, 72, 451, 452, 59, 60, 61, 62, 63, 64, 65, 66, 55, 56, 57, 58]
  },
  {
    id: 5,
    title: "A Voz dos Profetas e a Esperança Messiânica",
    description: "Profetas como Elias, Isaías, Jeremias, Ezequiel, Daniel e Miqueias surgem para chamar o povo ao arrependimento. Suas mensagens anunciam juízo, restauração e a vinda de um Salvador que traria luz em meio à escuridão.",
    songIds: [494, 495, 496, 497, 504, 67, 68, 505, 506, 507, 508, 502, 503, 498, 499, 500, 501, 509]
  },
  {
    id: 6,
    title: "O Nascimento e a Vida de Jesus",
    description: "Nos Evangelhos, vemos o cumprimento das promessas messiânicas. Jesus nasce, é batizado, ensina com autoridade, realiza milagres e compartilha parábolas que revelam o Reino de Deus.",
    songIds: [129, 79, 130, 131, 132, 80, 133, 81, 82, 83, 84, 78, 128, 140, 141, 73, 74, 75, 76, 77, 127]
  },
  {
    id: 7,
    title: "A Morte e Ressurreição de Cristo",
    description: "Jesus cumpre sua missão redentora ao entregar-se na cruz pelos pecados do mundo. Sua ressurreição sela a vitória sobre a morte e inaugura uma nova vida para todo aquele que crê.",
    songIds: [85, 86, 87, 88, 89, 90, 91, 92, 138, 93, 94, 95, 96, 97, 98, 99, 139]
  },
  {
    id: 8,
    title: "A Igreja e o Espírito Santo",
    description: "Com o Pentecostes, o Espírito Santo é derramado sobre os discípulos. A Igreja nasce, cresce e se espalha pelo mundo, impulsionada pelo amor, pelo ensino dos apóstolos e pelas cartas de Paulo.",
    songIds: [100, 101, 102, 103, 104, 105, 106, 426, 427, 428, 429, 430, 431, 108, 109, 110, 111, 112, 107]
  },
  {
    id: 9,
    title: "A Promessa da Eternidade",
    description: "O livro de Apocalipse nos revela o fim da história: o juízo final, a derrota definitiva do mal e a criação de novos céus e nova terra. Deus estará com Seu povo para sempre, sem dor, choro ou morte.",
    songIds: [115, 116, 113, 118, 119, 120, 114, 121, 122]
  }
];

